//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import { JobRequirements } from '@/components/_common/JobRequirements';
import { Typography } from '@mui/material';
import DateTimeDisplay from '@/components/_common/DateTimeDisplay';
import JobTypeLabel from '@/components/Job/JobTypeLabel';
import TableJobStage from '@/components//_common/Table/TableJobStage';
import { StatusColors } from '@/constants/constants';
import JobsOverflowMenu from '@/components/Jobs/JobsOverflowMenu';
import { JobDetail, OrderJob } from '@/redux/slices/slice_types';
import { getLineageMetaTitle } from '@/_utils/utils';
import { UserDisplay } from '@/exports/columnCommonComponents';
import { findandFormatUTCDateInString } from '@/_utils/date';

export default {
  hid: {
    label: 'Job ID',
    sortField: 'id',
    minWidth: 75,
    render: (cell: JobDetail['hid']) => <Typography variant="subtitle1">{cell}</Typography>
  },
  job_type: {
    label: 'Job Type',
    render: (cell: JobDetail['job_type']) => <JobTypeLabel type={cell} />
  },
  description: {
    label: 'Title',
    minWidth: 250,
    render: (_cell: any, job: OrderJob) => (
      <div>
        <Typography>
          <strong>{job.title?.name || job.description}</strong>
        </Typography>
        {!!job.title.children?.length && (
          <Typography variant="caption" sx={{ lineHeight: 1.9, fontSize: '.9rem' }}>
            {getLineageMetaTitle(job.title.children[0], true)}
          </Typography>
        )}
      </div>
    )
  },
  version__name: {
    label: 'Version',
    minWidth: 200
  },
  order__managed_by: {
    label: 'Managed By',
    disableSort: true,
    minWidth: 100,
    render: (cell: JobDetail['order']['managed_by'], job: OrderJob) =>
      cell ? <UserDisplay user={cell} emptyText="-" /> : job.order?.managed_by || '-'
  },
  customer: {
    label: 'Customer',
    minWidth: 180
  },
  profile__name: {
    label: 'Profile',
    sortField: 'job_profile',
    minWidth: 240,
    render: (cell: JobDetail['profile']) => findandFormatUTCDateInString(cell?.name)
  },
  due_date: {
    label: 'Due Date',
    width: 100,
    render: (cell: JobDetail['due_date']) => <DateTimeDisplay>{cell}</DateTimeDisplay>
  },
  created_at: {
    label: 'Created',
    width: 100,
    render: (cell: JobDetail['created_at']) => <DateTimeDisplay>{cell}</DateTimeDisplay>
  },
  stage: {
    label: 'Status',
    render: (cell: JobDetail['stage'], row: JobDetail) => (
      <TableJobStage
        status={row.status === 'cancelled' ? row.status : cell || row.status}
        colorOverride={StatusColors[row.status as keyof typeof StatusColors]}
      />
    )
  },
  assets: {
    label: 'Requirements',
    render: (cell: JobDetail['assets'], row: JobDetail) => (
      <div style={{ opacity: row.status === 'cancelled' ? '0.5' : '1', marginLeft: -15 }}>
        <JobRequirements sources={cell} />
      </div>
    ),
    tooltip: {
      title: 'Displays sources received out of the total expected',
      placement: 'top'
    }
  },
  overflow: {
    label: '',
    isOverflow: true,
    render: (_cell: any, job: OrderJob) => <JobsOverflowMenu row={job} />
  }
};
